import options from './header.component';

export default {
    selector: 'dtLayoutHeader',
    options
};



// WEBPACK FOOTER //
// ./app/common/header/index.js